"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.S3_BASE_URL = exports.CLOUDFRONT_BASE_URL = void 0;
exports.getMusicBucketPath = getMusicBucketPath;
exports.getMusicBucketWithoutFilename = getMusicBucketWithoutFilename;
exports.getMusicDownloadUrl = getMusicDownloadUrl;
exports.CLOUDFRONT_BASE_URL = 'https://d3i52mr356kz3z.cloudfront.net'; // 'http://d33wth2ud6g48.cloudfront.net';
/**
 * S3 base URL for music files
 * Uses environment variable S3_BASE_URL if available (server-side only)
 * Falls back to hardcoded URL for browser/client use
 * Environment variables required (server-side):
 *   - S3_BASE_URL (preferred, takes precedence)
 *   OR
 *   - AWS_BUCKET_NAME_MUSIC (bucket name)
 *   - AWS_REGION (S3 region)
 */
const getS3BaseUrl = () => {
    // Only use process.env on server side (Node.js)
    // This file is shared between server and client, so we check if process exists
    if (typeof process !== 'undefined' && process.env) {
        // Use explicit S3_BASE_URL env var if provided
        if (process.env.S3_BASE_URL) {
            return process.env.S3_BASE_URL;
        }
        // Otherwise construct from bucket name and region
        const bucketName = process.env.AWS_BUCKET_NAME_MUSIC;
        const region = process.env.AWS_REGION;
        if (bucketName && region) {
            // Always use HTTPS for S3 (S3 supports HTTPS in all environments)
            return `https://${bucketName}.s3-${region}.amazonaws.com`;
        }
    }
    // Fallback for client/browser or when no env vars configured
    return 'https://ascheandspencer-music-devjohn2.s3-us-west-2.amazonaws.com';
};
exports.S3_BASE_URL = getS3BaseUrl();
function getMusicBucketPath(music, musicType) {
    if (musicType === 'mp3') {
        return encodeURI(`${music.file_path_high
            .replace(' ', '+')
            .replace('music/', 'mp3/')}`);
    }
    return encodeURI(`wav/${music.filename
        .replace(' ', '+')
        .replace('.mp3', '.wav')}`);
}
function getMusicBucketWithoutFilename(music, musicType) {
    if (musicType === 'mp3') {
        return encodeURI(`${music.file_path_high
            .replace(' ', '+')
            .replace('music/', 'mp3/')}`).split("/").slice(0, 2).join("/");
    }
    return encodeURI(`wav/${music.filename
        .replace(' ', '+')
        .replace('.mp3', '.wav')}`);
}
function getMusicDownloadUrl(music, musicType, skipCDN) {
    return `${skipCDN ? exports.S3_BASE_URL : exports.CLOUDFRONT_BASE_URL}/${getMusicBucketPath(music, musicType)}`;
}
